(() => {
  const roots = document.querySelectorAll('[data-tromba-recipe-root]');

  roots.forEach((root) => {
    if (!(root instanceof HTMLElement) || root.dataset.trombaRecipeCartReady === 'true') return;
    root.dataset.trombaRecipeCartReady = 'true';

    const notification = root.querySelector('[data-tromba-recipe-cart-notification]');
    const notificationQuantity = root.querySelector('[data-tromba-recipe-cart-quantity]');
    const notificationError = root.querySelector('[data-tromba-recipe-cart-error]');
    const rootUrl = root.dataset.rootUrl || window.Shopify?.routes?.root || '/';
    const errorLabel = notification?.dataset.errorLabel || 'Something went wrong. Please try again.';

    const updateCartCount = async () => {
      const response = await fetch(`${rootUrl}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      const count = Number(cart.item_count || 0);
      window.sessionStorage?.setItem('cart-count', String(count));
      document.querySelectorAll('.tromba-header__cart-count, [data-cart-count], [ref="cartBubbleCount"]').forEach((node) => {
        node.textContent = String(count);
        node.classList.toggle('hidden', count === 0);
      });
      document.dispatchEvent(new CustomEvent('tromba:cart-updated', { detail: { cart } }));
    };

    const showNotification = (quantity, errorMessage = '') => {
      if (!(notification instanceof HTMLElement)) return;
      if (notificationQuantity) notificationQuantity.textContent = String(quantity || 1);
      if (notificationError instanceof HTMLElement) {
        notificationError.textContent = errorMessage;
        notificationError.hidden = errorMessage === '';
      }
      notification.hidden = false;
      notification.setAttribute('aria-hidden', 'false');
      window.requestAnimationFrame(() => notification.classList.add('is-visible'));
    };

    const hideNotification = () => {
      if (!(notification instanceof HTMLElement)) return;
      notification.classList.remove('is-visible');
      notification.setAttribute('aria-hidden', 'true');
      window.setTimeout(() => {
        if (!notification.classList.contains('is-visible')) notification.hidden = true;
      }, 220);
    };

    root.querySelector('[data-tromba-recipe-cart-close]')?.addEventListener('click', hideNotification);
    root.querySelector('[data-tromba-recipe-cart-continue]')?.addEventListener('click', hideNotification);

    root.querySelectorAll('[data-tromba-quick-add-form]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!(form instanceof HTMLFormElement) || form.dataset.cartSubmitting === 'true') return;

        const button = form.querySelector('button[type="submit"]');
        const formData = new FormData(form);
        const quantity = Number(formData.get('quantity') || 1);
        form.dataset.cartSubmitting = 'true';
        if (button instanceof HTMLButtonElement) {
          button.disabled = true;
          button.classList.add('is-loading');
        }

        try {
          const response = await fetch(`${rootUrl}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData,
            credentials: 'same-origin'
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || errorLabel);
          await updateCartCount();
          showNotification(quantity);
        } catch (error) {
          showNotification(quantity, error?.message || errorLabel);
        } finally {
          form.dataset.cartSubmitting = 'false';
          if (button instanceof HTMLButtonElement) {
            button.disabled = false;
            button.classList.remove('is-loading');
          }
        }
      });
    });

    root.querySelector('[data-tromba-recipe-cart-upsell]')?.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      if (!(button instanceof HTMLButtonElement) || button.disabled) return;
      button.disabled = true;
      button.classList.add('is-loading');

      try {
        const response = await fetch(`${rootUrl}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] }),
          credentials: 'same-origin'
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || errorLabel);
        button.textContent = button.dataset.addedLabel || 'Added';
        button.classList.remove('is-loading');
        await updateCartCount();
      } catch (error) {
        button.disabled = false;
        button.classList.remove('is-loading');
        if (notificationError instanceof HTMLElement) {
          notificationError.textContent = error?.message || errorLabel;
          notificationError.hidden = false;
        }
      }
    });
  });
})();